import datas from '../../datas/_datas';

const report = {
  thermix_href: "www.thermix.org",
  header: {
    title: "THERMIX",
    subtitle: "SIMULATIONS DE SYSTÈMES DE CHAUFFAGE",
    infos: {
      date: "Simulations réalisées le ",
    },
  },
  first_page: {
    main_title: "SYNTHÈSE DE SIMULATION",
    scenarii: {
      trend  : "Scénario tendanciel",
      crysis : "Scénario de crise énergétique",
      custom : "Scénario personnalisé",
    },
    savings: {
      title: "RÉSULTAT",
    },
    period_total_cost: {
      title: "RÉPARTITION DES DÉPENSES SUR " + datas.simulation_period + " ANS",
    },
    period_cost_evolution: {
      title: "RETOUR SUR INVESTISSEMENT SUR " + datas.simulation_period + " ANS",
    },
  },
  second_page: {
    environmental_impact: {
      title: "BILAN ENVIRONNEMENTAL DES MODES DE CHAUFFAGE",
      text: [ // don't remove "-"
        "Le bilan environnemental tient compte :",
        "-des émissions de CO2, sachant qu’un foyer français moyen émet 16 tonnes " +
        "par an pour tous les usages (transport, chauffage,consommation...) et " +
        "qu’il faudra diviser par 4 cette valeur d’ici 2050",
        "-des ressources primaires consommées comptabilisées en kilowattheure d’énergie primaire (kWhep)",
      ],
    },
    price_variation: {
      title: "AUGMENTATION DU PRIX DE L'ÉNERGIE",
      text : [
        "On constate que sur les " + datas.prices_variations_period +
        " dernières années, le prix des énergies a connu d’importantes " +
        "variations, mais a, en moyenne, fortement augmenté.",
        "Le prix des énergies en voie d’amenuisement (fioul, gaz, etc.) a " +
        "tendance à augmenter plus rapidement (environ +5% / an) que celui " +
        "des énergies produites à partir de ressources renouvelables produites " +
        "nationalement ou localement, telles que le bois (environ +3 % / an).",
        "Economiquement, il est souvent plus avantageux d’investir dans une " +
        "solution de chauffage basée sur une énergie peu onéreuse, et dont " +
        "le prix est moins susceptible d’augmenter même si l’investissement " +
        "de départ est plus élevé.",
      ]
    },
    solutions_resume: {
      title: "RAPPEL DES HYPOTHÈSES DE CALCUL",
      solution_header: "Solution",
      simulation_period: "* Moyenne effectuée sur les " + datas.simulation_period + " années à venir",
      heating_system: {
        solution: {
          title: "Système de chauffage choisi",
          font_weight: 'bold',
          units: "",
        },
        investment: {
          title: "Investissement (aides déduites)",
          font_weight: 'bold',
          units: "€",
        },
        needs: {
          title: "Besoin de chaleur pour chauffage",
          font_weight: 'normal',
          units: "kWh/an",
        },
        yearly_solar_prod: {
          title: "Apports énergie solaire thermique",
          font_weight: 'normal',
          units: "kWh/an",
        },
        yearly_energy_product : {
          title: "Chaleur restante à produire",
          font_weight: 'normal',
          units: "kWh/an",
        },
        efficiency: {
          title: "Rendement système ou COP",
          font_weight: 'normal',
          units: "%",
        },
        secondary_efficiency: {
          title: "Rendement distribution et émission",
          font_weight: 'normal',
          units: "%",
        },
        yearly_final_energy_consumption: {
          title: "Consommation d'énergie finale",
          font_weight: 'bold',
          units: "kWh/an",
        },
        energy_price: {
          title: "Prix de l'énergie",
          font_weight: 'normal',
          units: "c€/kWh",
        },
        energy_price_variation: {
          title: "Augmentation annuelle du prix de l'énergie",
          font_weight: 'normal',
          units: "%/an",
        },
        avg_yearly_energy_cost: {
          title: "Coût annuel du combustible *",
          font_weight: 'normal',
          units: "€/an",
        },
      },
      hot_water_system: {
        solution: {
          title: "Système de production ECS choisi",
          font_weight: 'bold',
          units: "",
        },
        investment: {
          title: "Investissement (aides déduites)",
          font_weight: 'bold',
          units: "€",
        },
        needs: {
          title: "Besoin de chaleur pour ECS",
          font_weight: 'normal',
          units: "kWh/an",
        },
        yearly_solar_prod: {
          title: "Apports énergie solaire thermique",
          font_weight: 'normal',
          units: "kWh/an",
        },
        yearly_energy_product : {
          title: "Production de chaleur par le système",
          font_weight: 'normal',
          units: "kWh/an",
        },
        efficiency: {
          title: "Rendement système ou COP",
          font_weight: 'normal',
          units: "%",
        },
        yearly_final_energy_consumption: {
          title: "Consommation d'énergie (finale)",
          font_weight: 'bold',
          units: "kWh/an",
        },
        energy_price: {
          title: "Prix de l'énergie",
          font_weight: 'normal',
          units: "c€/kWh",
        },
        energy_price_variation: {
          title: "Augmentation annuelle du prix de l'énergie",
          font_weight: 'normal',
          units: "%/an",
        },
        avg_yearly_energy_cost: {
          title: "Coût annuel du combustible *",
          font_weight: 'normal',
          units: "€/an",
        },
      },
      solar_system: {
        solution: {
          title: "Système solaire thermique choisi",
          font_weight: 'bold',
          units: "",
        },
        solar_area: {
          title: "Surface envisagée",
          font_weight: 'bold',
          units: "m2",
        },
        investment: {
          title: "Investissement (aides déduites)",
          font_weight: 'normal',
          units: "€",
        },
      },
      total: {
        yearly_energy_total_cost: {
          title: "Coût de revient annuel total *",
          font_weight: 'bold',
          units: "€/an",
        },
        enr_prod_ratio: {
          title: "Ratio d'énergie renouvelable",
          font_weight: 'bold',
          units: "%",
        },
        yearly_final_energy_consumption: {
          title: "Consommation totale d’énergie (finale)",
          font_weight: 'normal',
          units: "kWh/an",
        },
        primary_energy_ratio_consumption: {
          title: "Consommation d'énergie primaire",
          font_weight: 'normal',
          units: "kWh/an",
        },
        yearly_green_house_gaz: {
          title: "Émission de CO2",
          font_weight: 'normal',
          units: "kgCO2/an",
        },
        yearly_ghg_by_car: {
          title: "Émission de CO2 en équivalent km véhicule",
          font_weight: 'normal',
          units: "km/an",
        },
        // yearly_wood_mass: {
        //   title: "Masse de bois consommée",
        //   font_weight: 'normal',
        //   units: "t/an",
        // },
        yearly_wood_volume: {
          title: "Volume de bois consommée",
          font_weight: 'normal',
          units: "m3/an",
        },
      },
    },
  },
  footer: {
    at: "RAPPORT CRÉÉ LE ",
  },
};

export default report;



// WEBPACK FOOTER //
// ./assets/javascripts/i18n/report/fr.js